import { IActiveRequestsKeys } from '../actions/request_active';
import { IState } from '../lib/store';

export const isRequestActive = (request: IActiveRequestsKeys, state: IState): boolean =>
  state.requestActive[request];

export const someRequestActive = (requests: IActiveRequestsKeys[], state: IState): boolean =>
  requests.some((request) => isRequestActive(request, state));
